import type { EUROPACE_TYPE_COMPLETENESS_STATUS, EUROPACE_TYPE_FEASIBILITY_STATUS } from 'cpool-constants';
import { EUROPACE_COMPLETENESS_STATUS, EUROPACE_FEASIBILITY_STATUS } from 'cpool-constants';

export const isEuropaceOfferAcceptable = ({
    completenessStatus,
    feasibilityStatus,
}: {
    feasibilityStatus: EUROPACE_TYPE_FEASIBILITY_STATUS | undefined;
    completenessStatus: EUROPACE_TYPE_COMPLETENESS_STATUS | undefined;
}) =>
    (feasibilityStatus === EUROPACE_FEASIBILITY_STATUS.MACHBAR ||
        feasibilityStatus === EUROPACE_FEASIBILITY_STATUS.MACHBAR_UNTER_VORBEHALT) &&
    completenessStatus === EUROPACE_COMPLETENESS_STATUS.VOLLSTAENDIG;
